import { TipoIdentificacion } from "./tipo-identificacion";

export class Transportista{
    public constructor(
        public id: String = "",
        public tipo_identificacion_id: number = 0,
        public dni:String = "",
        public nombre:String = "",
        public placa:String = "",
        public empresa_id: String = "",
        public usuario_id:String = null,

        public tipoidentificacion:TipoIdentificacion = new TipoIdentificacion(),


    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/transportista.ts